import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "./authContext";

const verificationRequestCache = new Map();

function getVerificationRequest(token, verifyEmail) {
  if (!verificationRequestCache.has(token)) {
    const request = Promise.resolve().then(() => verifyEmail(token));
    verificationRequestCache.set(token, request);
    request.finally(() => {
      verificationRequestCache.delete(token);
    });
  }

  return verificationRequestCache.get(token);
}

export default function VerifyEmailView() {
  const [searchParams] = useSearchParams();
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Verifying email...");
  const token = String(searchParams.get("token") || "").trim();

  useEffect(() => {
    let isDisposed = false;

    if (!token) {
      setStatus("error");
      setMessage("Verification token is missing.");
      return undefined;
    }

    const runVerification = async () => {
      try {
        await getVerificationRequest(token, verifyEmail);

        if (!isDisposed) {
          setStatus("success");
          setMessage("Email verified. You are now logged in.");
        }
      } catch (error) {
        if (!isDisposed) {
          setStatus("error");
          setMessage(error.message || "Could not verify email.");
        }
      }
    };

    runVerification();

    return () => {
      isDisposed = true;
    };
  }, [token, verifyEmail]);

  return (
    <div className="account-shell">
      <section className="account-settings-panel" style={{ maxWidth: "760px", margin: "0 auto" }}>
        <div className="account-page-header">
          <div>
            <h1 className="account-page-title">Verify Email</h1>
            <p className="account-copy">Complete account verification so you can log in normally.</p>
          </div>
        </div>

        <div className={status === "error" ? "account-error" : status === "success" ? "account-notice" : "account-loading"}>
          {message}
        </div>

        <div style={{ marginTop: "20px" }}>
          <Link to={status === "success" ? "/account" : "/auth"} style={{ color: "#0f766e", fontWeight: 700, textDecoration: "none" }}>
            {status === "success" ? "Continue to account" : "Back to login"}
          </Link>
        </div>
      </section>
    </div>
  );
}